export default "__VITE_ASSET__BGmyEGmL__"